import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

export const ELEMENT_SELECTOR = '[data-truncate-tel]';
export const PLUGIN_NAME = 'truncateTel';

const log = debug('components/truncateTel');

class TruncateTel {
	constructor(element, options) {
		log('construct', element, options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.init();
	}

	init() {
		log('init', this.$target);
		this.button = this.makeButton();
		this.hideNumber();
		this.watch();
	}

	watch() {
		this.button.on('click', this.revealNumber.bind(this));
	}

	getButtonText() {
		return (
			this.$element
				.text()
				.trim()
				.split(' ')
				.slice(0, -1)
				.join(' ') + '…'
		);
	}

	makeButton() {
		const buttonHtml = $('<button></button>', {
			class: this.options.buttonClass,
			'aria-label': this.options.buttonLabel,
			type: 'button',
			text: this.getButtonText()
		});

		return buttonHtml;
	}

	hideNumber() {
		this.$element.addClass(this.options.hideNumberClass);
		this.button.insertAfter(this.$element);
	}

	revealNumber() {
		this.$element.removeClass(this.options.hideNumberClass).focus();
		this.button.detach();
	}
}

TruncateTel.DEFAULTS = {
	hideNumberClass: 'truncate-tel--hidden'
};

plugin(PLUGIN_NAME, TruncateTel);

$(document).ready(() => {
	$(ELEMENT_SELECTOR).each(function(index, element) {
		$(element)[PLUGIN_NAME]();
	});
});



// WEBPACK FOOTER //
// ./project/client/src/site__rbhs/components/truncate-tel/index.js